export const SCSS_VARS = 
{
  "$white": "#fff",
  "$gray-050": "#fafafa",
  "$gray-100": "#fafafa",
  "$gray-200": "#f0f2f6",
  "$gray-300": "#e6eaf1",
  "$gray-400": "#d5dae5",
  "$gray-500": "#bfc5d3",
  "$gray-600": "#a3a8b4",
  "$gray-700": "#808495",
  "$gray-800": "#555867",
  "$gray-900": "#262730",
  "$gray-1000": "#0e1117",
  "$black": "#262730",
  "$red": "#ff2b2b",
  "$yellow": "#faca2b",
  "$blue": "#0068c9",
  "$green": "#09ab3b",
  "$gray-faint": "#fafafa",
  "$gray-lightest": "#f0f2f6",
  "$gray-lighter": "#e6eaf1",
  "$gray-light": "#d5dae5",
  "$gray": "#a3a8b4",
  "$gray-dark": "#808495",
  "$gray-darker": "#262730",
  "$yellow-light": "#fffd80",
  "$primary": "#f63366",
  "$secondary": "#a3a8b4",
  "$light": "#fafafa",
  "$dark": "#a3a8b4",
  "$primary-a50": "rgba(246,51,102,0.5)",
  "$white-a50": "#fff88",
  "$white-a25": "#fff44",
  "$font-family-sans-serif": "\"IBM Plex Sans\",sans-serif",
  "$font-family-monospace": "\"IBM Plex Mono\",monospace",
  "$font-size-base": "1rem",
  "$font-size-sm": ".8rem",
  "$line-height-base": "1.6",
  "$line-height-tight": "1.25",
  "$border-radius": ".25rem",
  "$border-radius-sm": ".25rem",
  "$border-radius-large": ".75rem",
  "$btn-border-radius": ".75rem",
  "$z-index-popup-menu": "140",
  "$z-index-sidebar-mobile": "130",
  "$z-index-header": "120",
  "$z-index-menu-button": "110",
  "$z-index-sidebar": "100",
  "$m1-2-font-size-sm": ".8rem / 2",
  "$m2-3-font-size-sm": ".53333rem",
  "$m1-2-font-size-base": "1rem / 2",
  "$sidebar-width": "21rem",
  "$content-max-width": "730px",
  "$header-height": "3.5rem",
  "$top-margin": "5rem",
  "$bottom-margin": "10rem",
  "$fullscreen-button": "2rem",
  "$fullscreen-padding": ".75rem",
  "$fullscreen-padding-top": "3.5rem",
  "$overlayBtn-height": "2.5rem",
  "$overlayBtn-width": "2.5rem",
  "$overlayBtn-opacity-visible": ".25",
  "$overlayBtn-opacity-active": ".75",
  "$normal-animation-duration": "300ms",
  "$code-color": "#09ab3b",
  "$kbd-color": "#09ab3b",
  "$kbd-bg": "#fafafa",
  "$pre-color": "#262730"
}
